module.exports = __webpack_public_path__ + "media/images/front/dr_otsuki_m-bb5f6863be7b438ef18b25d179165c90.jpg";